module.exports = __webpack_public_path__ + "static/media/book.728666a8.svg";